import {
  ButtonGroup,
  ButtonSizeEnum,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  IconSizeEnum,
  LoaderIcon,
  RefreshIcon,
  Tooltip,
  Typography,
} from '@acceso/design-system';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type TBroadcastScheduleProgramHeaderButtonExtraProps = {
  isLoading: boolean;
  queryKey: readonly unknown[];
};

export function BroadcastScheduleProgramHeaderButtonExtra({
  isLoading,
  queryKey,
}: TBroadcastScheduleProgramHeaderButtonExtraProps) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const onClickRefresh = () => {
    if (isLoading) return;

    queryClient.resetQueries({
      queryKey,
    });
  };

  return (
    <Tooltip help={t('Refrescar')} grow>
      <ButtonGroup size={ButtonSizeEnum.SM} onClick={onClickRefresh} className="!border">
        <Typography
          fontSize={FontSizeEnum.Basic}
          weight={FontWeightEnum.Semibold}
          color={FontColorEnum.Dark10}
        >
          {isLoading ? (
            <LoaderIcon size={IconSizeEnum.SM} />
          ) : (
            <RefreshIcon size={IconSizeEnum.SM} />
          )}
        </Typography>
      </ButtonGroup>
    </Tooltip>
  );
}
